import {Component, OnInit, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef} from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject,  } from 'rxjs';
import {takeUntil} from "rxjs/operators";
import {SystemApp} from "../../constans/SystemConfigurations";
import {ApiUrl} from "../../shared/models/apiurl.models";
import {Router} from "@angular/router";
import { DragScrollDirective } from '../../shared/directives/drag-scroll.directive';

interface LabelIcon {
  id: number;
  label: string;
  icon: string;
}

interface CityInfo {
  id: number;
  label: string;
  name: string;
}

interface JobPost {
  id?: number;
  jobTitle: string;
  jobDescription: string;
  companyName: string;
  companyDescription: string;
  jobCategory: LabelIcon;
  jobType: LabelIcon;
  workLocationType: LabelIcon;
  city: CityInfo;
  region: LabelIcon;
  salaryFrom: string;
  salaryTo: string;
  salaryType: LabelIcon;
  isNegotiable: boolean;
  educationLevel: LabelIcon;
  skills: LabelIcon;
  languages: LabelIcon;
  isAnonymous: boolean;
  images: Array<[number, string]>;
  adsRoute: string;
}

interface JobListResponse {
  page_size: number;
  object_list: JobPost[];
}

@Component({
    selector: 'app-job-circles-banner',
    imports: [
    DragScrollDirective
],
    templateUrl: './required.component.html',
    styleUrls: ['./required.component.scss']
})
export class JobCirclesBannerComponent implements OnInit, OnDestroy {
  @ViewChild('scrollTrack') scrollTrackRef!: ElementRef<HTMLDivElement>;

  jobs: JobPost[] = [];
  _loading = true;
  get loading (){
    return this._loading
  }

  set loading(loading: boolean){
    this._loading = loading;
  }

  error = false;

  hoveredId: number | null = null;
  hoveredJob: JobPost | null = null;
  tipPos = { top: 0, left: 0 };

  private scrollAmount = 200;
  private destroy$ = new Subject<void>();
  private apiUrl = SystemApp.base_url_api+'/clientAjax/productVFilteriewSet';
  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json, text/plain, */*',
      'Authorization': this.apiKey.getJWTToken()
    })
  }

  private categoryColors: Record<string, string> = {
    'הנדסה': '#3A7BE8',
    'תוכנה': '#6C5CE7',
    'שיווק': '#E83A8A',
    'עיצוב': '#3AE89C',
    'חשבונאות': '#E8A43A',
    'בניה': '#E8563A',
    'מכירות': '#00ACC1',
    'default': '#6C5CE7',
  };

  constructor(private http: HttpClient, private apiKey: ApiUrl, private cdr: ChangeDetectorRef, private route:Router ) {}

  ngOnInit(): void {
    this.fetchJobs();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  fetchJobs(): void {
    this.loading = true;
    this.error = false;


    const params = {
      limit: '36',
      offset: '1',
      model_class: 'required'
    };

    this.http
        .post<JobListResponse>(this.apiUrl, {}, { headers:this.options.headers, params:params })
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => {
            this.jobs = res.object_list || [];
            this.loading = false;
            this.cdr.markForCheck();
          },
          error: () => {
            this.error = true;
            this.loading = false;
            this.cdr.markForCheck();
          }
        });
  }

  /** Scroll the track to the right (RTL: shows more items to the left visually) */
  scrollRight(): void {
    this.scrollTrackRef?.nativeElement.scrollBy({
      left: -this.scrollAmount,
      behavior: 'smooth'
    });
  }

  /** Scroll the track to the left (RTL: shows more items to the right visually) */
  scrollLeft(): void {
    this.scrollTrackRef?.nativeElement.scrollBy({
      left: this.scrollAmount,
      behavior: 'smooth'
    });
  }

  onHover(event: MouseEvent, job: JobPost, index: number): void {
    this.hoveredId = index;
    this.hoveredJob = job;

    const el = event.currentTarget as HTMLElement;
    const rect = el.getBoundingClientRect();

    this.tipPos = {
      top: rect.top - 10,
      left: rect.left + rect.width / 2
    };
  }

  onLeave(): void {
    this.hoveredId = null;
    this.hoveredJob = null;
  }

  navigateToPage(pageId: number): void{
    this.route.navigate([`./single/${pageId}`])
  }

  navigateToJobs(): void {
    this.route.navigate(['/shop/required']);
  }

  getCategoryColor(category?: string): string {
    if (!category) return this.categoryColors['default'];
    return this.categoryColors[category] || this.categoryColors['default'];
  }

  formatSalary(job: JobPost): string {
    const from = parseInt(job.salaryFrom, 10);
    const to = parseInt(job.salaryTo, 10);
    if (isNaN(from) || isNaN(to)) return '';
    const type = job.salaryType?.label || '';
    const negotiable = job.isNegotiable ? ' (גמיש)' : '';
    return `₪${from.toLocaleString()} – ₪${to.toLocaleString()} ${type}${negotiable}`;
  }

  getShortTitle(job: JobPost): string {
    return job.jobTitle || job.jobCategory?.label || 'משרה חדשה';
  }

  getInitials(name: string): string {
    if (!name) return '?';
    const words = name.trim().split(/\s+/);
    return words.length >= 2
        ? words[0][0] + words[1][0]
        : words[0].substring(0, 2);
  }

  getFirstImage(job: JobPost): string | null {
    if (!job.images?.length) return null;
    const img = job.images[0];
    if (Array.isArray(img) && img.length >= 2) {
      return img[1] as string;
    }
    return null;
  }
}
